import type { RootActions, RootGetters, RootState } from './types'
import { defineStore } from 'pinia'
import { Breakpoints } from '@/enum/Breakpoints'

const savedIsMenuOpen = localStorage.getItem('isMenuOpen')
const savedIsApiDocsMenuOpen = localStorage.getItem('isApiDocsMenuOpen')
const isMobile = window.innerWidth < Breakpoints.TABLET

export const useUIStore = defineStore<string, RootState, RootGetters, RootActions>('ui', {
  state() {
    return {
      isMenuOpen: savedIsMenuOpen !== null ? savedIsMenuOpen === 'true' : true,
      isApiDocsMenuOpen: isMobile
        ? false
        : savedIsApiDocsMenuOpen !== null
          ? savedIsApiDocsMenuOpen === 'true'
          : true,
      isFullscreenModalOpen: false,
    }
  },
  getters: {
    getIsMenuOpen(state: RootState) {
      return state.isMenuOpen
    },
    getIsApiDocsMenuOpen(state: RootState) {
      return state.isApiDocsMenuOpen
    },
  },
  actions: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    toggleApiDocsMenu() {
      this.isApiDocsMenuOpen = !this.isApiDocsMenuOpen
    },
  },
})
